import moment from 'moment';
import {i18n} from 'src/i18n';
import InventarioService from 'src/modules/inventario/inventarioService';
import InventarioListActions from 'src/modules/inventario/list/inventarioListActions';
import layoutActions from 'src/modules/layout/layoutActions';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'INVENTARIO_FORM';

const inventarioFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: inventarioFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await InventarioService.find(id);
      }

      dispatch({
        type: inventarioFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: inventarioFormActions.INIT_ERROR,
      });

      getHistory().push('/inventario');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: inventarioFormActions.CREATE_STARTED,
      });

      await InventarioService.create(values);

      dispatch({
        type: inventarioFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.inventario.create.success'));

      // getHistory().push('/inventario');

      dispatch(InventarioListActions.doFetchCurrentFilter());
      dispatch(
        layoutActions.doVisibleDrawer({
          drawerId: 'DrawerInventarioFormPage',
          drawerVisible: false,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: null,
        }),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: inventarioFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: inventarioFormActions.UPDATE_STARTED,
      });

      await InventarioService.update(id, values);

      dispatch({
        type: inventarioFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.inventario.update.success'));

      // getHistory().push('/inventario');

      dispatch(InventarioListActions.doFetchCurrentFilter());
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: inventarioFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default inventarioFormActions;
